import { API } from "@/constants";
import { get } from "./api";

export const getSampleQuestions = async (): Promise<any> => {
  return get<any>(`${API.SAMPLES}`);
};
